import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { ActiveAgreementsFilterData } from '../../types/activeAgreements';
import { ACTIVE_AGREEMENTS_ACTIONS_NAME, ACTIVE_AGREEMENTS_MUTATIONS_NAME } from './name.js';
import { TActiveAgreementsState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchAgreements(
  context: ActionContext<TActiveAgreementsState, unknown>,
  payload: TBaseFilterPayload<ActiveAgreementsFilterData & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ves.activeAgreements.searchAgreements,
      name: ACTIVE_AGREEMENTS_ACTIONS_NAME.searchAgreements,
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getAgreementsCount(
  context: ActionContext<TActiveAgreementsState, unknown>,
  params: ActiveAgreementsFilterData,
) {
  context.commit(getLocalState(ACTIVE_AGREEMENTS_MUTATIONS_NAME.setIsLoadingCount), true);
  await request(
    context,
    {
      url: links.ves.activeAgreements.getAgreementsCount,
      mutate: getLocalState(ACTIVE_AGREEMENTS_MUTATIONS_NAME.setAgreementsCount),
      name: getLocalState(ACTIVE_AGREEMENTS_ACTIONS_NAME.getAgreementsCount),
    },
    params,
  );
  context.commit(getLocalState(ACTIVE_AGREEMENTS_MUTATIONS_NAME.setIsLoadingCount), false);
}

export async function getAgreementTypes(context: ActionContext<TActiveAgreementsState, unknown>) {
  return request(
    context,
    {
      url: links.ves.events.getAgreementTypes,
      mutate: getLocalState(ACTIVE_AGREEMENTS_MUTATIONS_NAME.setAgreementTypes),
      name: getLocalState(ACTIVE_AGREEMENTS_ACTIONS_NAME.getAgreementTypes),
    },
    {},
  );
}
